import React from 'react';
import '../CSS/footer.css';

export default function Footer() {
  return (
    <>
        <footer>Website created by Monica &#169; 2022</footer>
    </>
  )
}
